import styled from "styled-components";

const Main = (props) => {
  return <div>this is the middle part</div>;
};

export default Main;

